import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InsightsDashboardsComponent } from './insights-dashboards.component';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SharedModule } from '../../shared/shared.module';
import { IconComponent } from '../icon/icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [InsightsDashboardsComponent],
    exports: [InsightsDashboardsComponent],
    imports: [
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        IconComponent,
        MatTooltipModule,
    ],
    providers: [],
})
export class InsightsDashboardsModule {}
